(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pt-chat-widget"] && !Shopify.designMode) return;
  try {
    (function () {
  var root = document.getElementById('pt-chat');
  if (!root) return;
  var api = root.getAttribute('data-api');
  var msgs = root.querySelector('[data-pt-chat-messages]');
  var form = root.querySelector('[data-pt-chat-form]');
  var panel = root.querySelector('.pt-chat__panel');
  var input = form.querySelector('.pt-chat__input');
  var sendBtn = form.querySelector('.pt-chat__send');
  var started = false;

  // --- Live staff replies (console takeover) -------------------------------
  // When a team member takes a chat over in the Agent Console, their replies
  // come back through this poll endpoint, not the POST response. We only poll
  // while a chat is in "human" mode, so normal AI chats make zero extra calls.
  var pollUrl = api + '/poll';
  var lastAt = '';
  var pollTimer = null;
  var humanMode = false;
  var connectedNote = false;
  var seenAt = {};

  // Per-year vehicle dataset base (same data the homepage trim picker uses).
  var assetBase = root.getAttribute('data-asset-base') || '';
  var manifestUrl = root.getAttribute('data-manifest-url') || '';
  var vehicleCache = {};
  var bookingFormEl = null;

  // Suggested-question chips shown when the chat opens (tap to send).
  var chipsEl = null;
  var CHIPS = [
    { label: 'Find tires', send: "I'm looking for tires for my vehicle" },
    { label: 'Find rims', send: "I'm looking for rims for my vehicle" },
    { label: 'Find a package', send: "I'm looking for a tire and wheel package" },
    { label: 'Book appointment', send: "I'd like to book an appointment" }
  ];

  function sessionId() {
    var k = 'pt_chat_sid';
    var v = '';
    try { v = localStorage.getItem(k) || ''; } catch (e) {}
    if (!v) {
      v = 'w-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      try { localStorage.setItem(k, v); } catch (e) {}
    }
    return v;
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function linkify(s) {
    return esc(s).replace(/(https?:\/\/[^\s]+)/g, function (u) {
      return '<a href="' + u + '" target="_blank" rel="noopener">' + u + '</a>';
    });
  }
  function addMsg(text, who) {
    var el = document.createElement('div');
    el.className = 'pt-chat__msg pt-chat__msg--' + who;
    el.innerHTML = who === 'bot' ? linkify(text) : esc(text);
    msgs.appendChild(el);
    msgs.scrollTop = msgs.scrollHeight;
    return el;
  }

  function removeChips() { if (chipsEl) { chipsEl.remove(); chipsEl = null; } }
  function renderChips() {
    if (chipsEl) return;
    chipsEl = document.createElement('div');
    chipsEl.className = 'pt-chat__chips';
    for (var k = 0; k < CHIPS.length; k++) {
      (function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pt-chat__chip';
        b.textContent = c.label;
        b.addEventListener('click', function () { removeChips(); sendMessage(c.send); });
        chipsEl.appendChild(b);
      })(CHIPS[k]);
    }
    msgs.appendChild(chipsEl);
    msgs.scrollTop = msgs.scrollHeight;
  }

  // Tappable picker shown when a vehicle has several sizes. Like the homepage
  // search: if we know year/make/model, load the per-year dataset and show the
  // customer's TRIM buttons (tap trim -> exact size). Falls back to size buttons
  // when the dataset doesn't have the vehicle.
  function renderSizePicker(opts) {
    if (!opts) return;
    if (opts.year && opts.make && opts.model && assetBase) {
      loadTrims(opts, function (items) {
        if (items && items.length) { renderPickerButtons(items); ptSearch(opts, 'sizes', items, 'trims'); }
        else renderPickerFromOpts(opts);
      });
      return;
    }
    renderPickerFromOpts(opts);
  }

  function renderPickerFromOpts(opts) {
    var items = [];
    var kind = 'sizes';
    if (opts.trims && opts.trims.length) {
      kind = 'trims';
      for (var t = 0; t < opts.trims.length; t++) items.push({ label: opts.trims[t].trim + ' - ' + opts.trims[t].size, send: opts.trims[t].size, size: opts.trims[t].size });
    } else if (opts.sizes && opts.sizes.length) {
      for (var s = 0; s < opts.sizes.length; s++) items.push({ label: opts.sizes[s], send: opts.sizes[s], size: opts.sizes[s] });
    }
    if (items.length) renderPickerButtons(items);
    ptSearch(opts, items.length ? 'sizes' : 'no_sizes', items, kind);
  }

  // Cross-surface search analytics — the agent resolved a vehicle to size
  // choices (or couldn't). One pt_search_submit + one pt_search_result per
  // resolution. Schema: snippets/pt-search-tracking.liquid. Chat text is never
  // sent. Never throws.
  function ptSearch(opts, outcome, items, kind) {
    if (!window.PTTrack || !opts) return;
    items = items || [];
    var first = (opts.sizes && opts.sizes[0]) || (opts.trims && opts.trims[0] && opts.trims[0].size) || null;
    // sizes_count counts distinct SIZES; when the picker is a trim list, the
    // number of buttons is trims_count. Six trims sharing one OEM size is one
    // size, not six.
    var seen = {}, sizeCount = 0;
    items.forEach(function (it) {
      var sz = it && it.size;
      if (!sz || seen[sz]) return;
      seen[sz] = true; sizeCount++;
    });
    var key = [opts.year, opts.make, opts.model, outcome].join('|');
    window.PTTrack.once('ch-s|' + key, 'pt_search_submit', {
      surface: 'chat', method: 'text',
      year: opts.year, make: opts.make, model: opts.model
    });
    window.PTTrack.once('ch-r|' + key, 'pt_search_result', {
      surface: 'chat', method: 'text', outcome: outcome,
      sizes_count: sizeCount, trims_count: kind === 'trims' ? items.length : null,
      year: opts.year, make: opts.make, model: opts.model,
      size: outcome === 'sizes' ? first : null
    });
  }

  function renderPickerButtons(items) {
    var wrap = document.createElement('div');
    wrap.className = 'pt-chat__chips';
    for (var k = 0; k < items.length; k++) {
      (function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pt-chat__chip';
        b.textContent = it.label;
        b.addEventListener('click', function () { wrap.remove(); sendMessage(it.send); });
        wrap.appendChild(b);
      })(items[k]);
    }
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  // Load the homepage's per-year dataset and resolve this vehicle's trims->sizes.
  function loadTrims(opts, cb) {
    var year = String(opts.year);
    function build(data) {
      if (!data || !data.models) return cb(null);
      var makeKey = findKey(data.models, opts.make);
      if (!makeKey) return cb(null);
      var modelKey = findKey(data.models[makeKey], opts.model);
      if (!modelKey) return cb(null);
      var trims = data.models[makeKey][modelKey];
      var items = [];
      Object.keys(trims).forEach(function (trim) {
        var sizes = trims[trim];
        var size = (sizes && sizes.length) ? sizes[0] : '';
        // `size` rides along for analytics only — renderPickerButtons reads
        // label/send. It lets sizes_count count sizes instead of buttons.
        if (size) items.push({ label: trim, send: 'My trim is ' + trim + ' (' + size + ')', size: size });
      });
      cb(items);
    }
    if (vehicleCache[year]) return build(vehicleCache[year]);
    // Cache-bust with the manifest's per-year version when pt-vehicle-manifest.json
    // loads (waits at most 1.5s); on a 404 the fetch stays unversioned as before.
    var PTVM = window.PTVehicleManifest;
    (PTVM ? PTVM.ready(manifestUrl, 1500) : Promise.resolve(null))
      .then(function (manifest) {
        return fetch(PTVM
          ? PTVM.yearUrl(assetBase, year, manifest, '')
          : assetBase + 'pt-vehicle-' + year + '.json');
      })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { vehicleCache[year] = data; build(data); })
      .catch(function () { cb(null); });
  }

  // Case-insensitive key match (exact -> prefix -> contains) so the agent's
  // make/model strings map onto the dataset keys.
  function findKey(obj, name) {
    if (!obj || !name) return null;
    var n = String(name).toLowerCase().trim();
    var keys = Object.keys(obj);
    var i;
    for (i = 0; i < keys.length; i++) if (keys[i].toLowerCase() === n) return keys[i];
    for (i = 0; i < keys.length; i++) { var k = keys[i].toLowerCase(); if (k.indexOf(n) === 0 || n.indexOf(k) === 0) return keys[i]; }
    for (i = 0; i < keys.length; i++) if (keys[i].toLowerCase().indexOf(n) > -1) return keys[i];
    return null;
  }

  // Booking-details form (name/phone/email) — shown when the agent is ready to
  // book, instead of asking for each field one at a time.
  function renderBookingForm(b) {
    if (!b || bookingFormEl) return;
    bookingFormEl = document.createElement('div');
    bookingFormEl.className = 'pt-chat__bform';
    var when = (b.label || 'your appointment') + (b.time ? ' at ' + b.time : '');
    bookingFormEl.innerHTML =
      '<div class="pt-chat__bform-title">Your details to request ' + esc(when) + ' — we\'ll confirm by email, usually within the day.</div>' +
      '<input class="pt-chat__bform-in" data-bf-name type="text" placeholder="Full name" autocomplete="name" />' +
      '<input class="pt-chat__bform-in" data-bf-phone type="tel" placeholder="Phone number" autocomplete="tel" />' +
      '<input class="pt-chat__bform-in" data-bf-email type="email" placeholder="Email" autocomplete="email" />' +
      '<button class="pt-chat__bform-btn" type="button">Send request</button>' +
      '<div class="pt-chat__bform-err"></div>';
    msgs.appendChild(bookingFormEl);
    msgs.scrollTop = msgs.scrollHeight;
    var el = bookingFormEl;
    var nameI = el.querySelector('[data-bf-name]');
    var phoneI = el.querySelector('[data-bf-phone]');
    var emailI = el.querySelector('[data-bf-email]');
    var btn = el.querySelector('.pt-chat__bform-btn');
    var err = el.querySelector('.pt-chat__bform-err');
    setTimeout(function () { nameI.focus(); }, 60);
    btn.addEventListener('click', function () {
      var nm = (nameI.value || '').trim(), ph = (phoneI.value || '').trim(), em = (emailI.value || '').trim();
      if (!nm || ph.length < 7 || em.indexOf('@') < 1) { err.textContent = 'Please add your name, phone, and a valid email.'; return; }
      el.remove(); bookingFormEl = null;
      addMsg(nm + ' · ' + ph + ' · ' + em, 'user');
      sendMessage('My booking details: name ' + nm + ', phone ' + ph + ', email ' + em, true);
    });
  }

  // Tappable appointment-time buttons. Tapping sends the chosen time (with the
  // day, so the agent has full context) and continues the booking.
  function renderSlots(b) {
    if (!b || !b.slots || !b.slots.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'pt-chat__chips';
    for (var k = 0; k < b.slots.length; k++) {
      (function (time) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pt-chat__chip';
        btn.textContent = time;
        btn.addEventListener('click', function () { wrap.remove(); sendMessage("I'll take " + time + (b.label ? ' on ' + b.label : '')); });
        wrap.appendChild(btn);
      })(b.slots[k]);
    }
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  // Tappable product recommendation cards from recommend_tires (image, brand +
  // model, size, price, ⭐ rating where available). Each card links to the PDP.
  function renderProductCards(cards) {
    if (!cards || !cards.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'pt-chat__cards';
    for (var k = 0; k < cards.length; k++) {
      (function (c) {
        var a = document.createElement('a');
        a.className = 'pt-chat__card';
        a.href = c.url || '#'; a.target = '_blank'; a.rel = 'noopener';
        var img = c.image
          ? '<img class="pt-chat__card-img" src="' + esc(c.image) + '" alt="' + esc(c.title || '') + '" loading="lazy" />'
          : '<div class="pt-chat__card-img pt-chat__card-img--ph"></div>';
        var brandModel = esc(((c.vendor || '') + ' ' + (c.model || '')).trim()) || esc(c.title || 'Tire');
        var price = (typeof c.priceCents === 'number') ? ('$' + (c.priceCents / 100).toFixed(2) + ' ea') : '';
        var rating = (c.rating && typeof c.rating.score === 'number')
          ? ' · <span class="pt-chat__card-rating">★ ' + Math.round(c.rating.score) + '/100</span>' : '';
        var pro = (c.rating && c.rating.pros && c.rating.pros.length)
          ? '<div class="pt-chat__card-tags">' + esc(c.rating.pros[0]) + '</div>' : '';
        a.innerHTML =
          img +
          '<div class="pt-chat__card-body">' +
            '<div class="pt-chat__card-title">' + brandModel + '</div>' +
            '<div class="pt-chat__card-meta">' + esc(c.size || '') + rating + '</div>' +
            pro +
            '<div class="pt-chat__card-foot"><span class="pt-chat__card-price">' + price + '</span><span class="pt-chat__card-cta">View</span></div>' +
          '</div>';
        wrap.appendChild(a);
      })(cards[k]);
    }
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;
  }

  // Render a shop-side message once, keyed by its server timestamp, so two
  // overlapping polls can never show the same reply twice.
  function renderShop(text, at) {
    if (at) { if (seenAt[at]) return; seenAt[at] = 1; }
    addMsg(text, 'bot');
  }
  function poll() {
    fetch(pollUrl + '?sessionId=' + encodeURIComponent(sessionId()) + '&after=' + encodeURIComponent(lastAt))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data) return;
        if (data.messages && data.messages.length) {
          for (var j = 0; j < data.messages.length; j++) renderShop(data.messages[j].text, data.messages[j].at);
        }
        if (data.cursor) lastAt = data.cursor;
      })
      .catch(function () {});
  }
  function startPolling() {
    if (pollTimer) return;
    lastAt = ''; // baseline: ignore prior history, only catch replies from here on
    poll();
    pollTimer = setInterval(poll, 5000);
  }
  function stopPolling() {
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
  }

  var mq = window.matchMedia('(max-width: 768px)');
  // On phones the on-screen keyboard shrinks the visual viewport and would
  // otherwise cover the input and the agent's latest reply. Resize the panel to
  // sit just above the keyboard and keep the newest message in view.
  function fitPanel() {
    if (!mq.matches || !window.visualViewport || !root.classList.contains('is-open')) {
      panel.style.bottom = ''; panel.style.height = '';
      return;
    }
    var vv = window.visualViewport;
    var keyboard = Math.max(0, window.innerHeight - (vv.offsetTop + vv.height));
    if (keyboard > 60) {
      panel.style.bottom = (keyboard + 10) + 'px';
      panel.style.height = Math.max(240, vv.height - 90) + 'px';
    } else {
      panel.style.bottom = ''; panel.style.height = '';
    }
    msgs.scrollTop = msgs.scrollHeight;
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitPanel);
    window.visualViewport.addEventListener('scroll', fitPanel);
  }

  function open() {
    root.classList.add('is-open');
    if (!started) {
      started = true;
      addMsg("👋 Hi, I'm the Prince Tires assistant! I can help you:\n• Find the right tires — by your vehicle (year/make/model), VIN, or size\n• See live prices & book an install or service\n• Check what size & which wheels fit your car\n• Snap a photo of your tire sidewall and I'll read the size\n\nWhat can I help you with? Tap a suggestion below or just ask 👇", 'bot');
      renderChips();
    }
    if (humanMode) startPolling(); // a staff member is handling this chat
    setTimeout(function () { input.focus(); fitPanel(); }, 50);
  }
  function close() {
    root.classList.remove('is-open');
    stopPolling();
    panel.style.bottom = ''; panel.style.height = '';
  }

  // Re-fit when the keyboard opens/closes (focus/blur fire just before the
  // viewport animates, so give it a beat to settle).
  input.addEventListener('focus', function () { setTimeout(fitPanel, 200); });
  input.addEventListener('blur', function () { setTimeout(fitPanel, 200); });

  // On phones, "Chat" opens the visitor's texting app instead of the in-page
  // chat — texting is the natural mobile channel and it hands us their number to
  // reply. Desktop keeps the web chat. 768px = the theme's mobile breakpoint (mq).
  var SMS_NUMBER = '+14034524283'; // (403) 452-4283 — one line takes calls + texts
  var SMS_BODY = 'Hi Prince Tires, I have a question';
  function smsHref() {
    // iOS expects sms:<number>&body=... ; Android/others expect ...?body=...
    var isIOS = /iP(hone|ad|od)/.test(navigator.userAgent || '');
    return 'sms:' + SMS_NUMBER + (isIOS ? '&' : '?') + 'body=' + encodeURIComponent(SMS_BODY);
  }

  // Bind every opener (the desktop bubble AND the mobile bottom-bar "Chat" tab).
  // On mobile we send them to SMS; on desktop we open the in-page panel.
  var openers = document.querySelectorAll('[data-pt-chat-open]');
  for (var i = 0; i < openers.length; i++) {
    openers[i].addEventListener('click', function (e) {
      e.preventDefault();
      if (mq.matches) { window.location.href = smsHref(); return; }
      open();
    });
  }
  root.querySelector('[data-pt-chat-close]').addEventListener('click', close);

  var sending = false;
  var contactUrl = api + '/contact';
  var gateEl = null;
  // Desktop contact capture: ask name + email after the first message so the
  // shop can always follow up. Remembered per browser so we don't re-ask.
  var contactCaptured = false;
  try { contactCaptured = !!localStorage.getItem('pt_chat_contact'); } catch (e) {}
  var userMsgCount = 0;

  // Product-aware chat: on a PDP the container carries data-pt-product-* attrs,
  // so the agent knows which tire the visitor is looking at.
  function ptProduct() {
    var h = root.getAttribute('data-pt-product-handle');
    if (!h) return null;
    return {
      handle: h,
      title: root.getAttribute('data-pt-product-title') || '',
      vendor: root.getAttribute('data-pt-product-vendor') || '',
      size: root.getAttribute('data-pt-product-size') || '',
      price: root.getAttribute('data-pt-product-price') || ''
    };
  }

  function sendMessage(text, resume, image) {
    if (sending || (!text && !image)) return;
    removeChips(); // they've engaged — clear the starter chips
    if (!resume) userMsgCount++; // count genuine visitor turns (not booking resumes)
    sending = true;
    if (!resume && text) addMsg(text, 'user'); // on resume (or photo-only) the bubble is already shown
    sendBtn.disabled = true;

    var typing = document.createElement('div');
    typing.className = 'pt-chat__typing';
    typing.textContent = 'typing...';
    msgs.appendChild(typing);
    msgs.scrollTop = msgs.scrollHeight;

    fetch(api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: sessionId(), message: text, product: ptProduct(), image: image || undefined })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        typing.remove();
        // Per-chat cap reached - stop the AI and offer an OPTIONAL follow-up.
        if (data && data.capReached) {
          addMsg((data && data.reply) || "Thanks for chatting! Call or text (403) 452-4283 and we'll help.", 'bot');
          showFollowUp();
          return;
        }
        if (data && data.state === 'human') {
          // A staff member is handling this chat — their replies arrive via poll.
          humanMode = true;
          if (!connectedNote) {
            connectedNote = true;
            addMsg("You're connected to the Prince Tires team. Someone will reply right here.", 'bot');
          }
          startPolling();
          return;
        }
        if (data && data.state === 'bot') {
          if (data.reply) renderShop(data.reply, data.at);
          if (data.tireSizeOptions) renderSizePicker(data.tireSizeOptions);
          if (data.bookingSlots) renderSlots(data.bookingSlots);
          if (data.bookingForm) renderBookingForm(data.bookingForm);
          if (data.productCards) renderProductCards(data.productCards);
          // AI flagged a handoff — start watching for a team member's reply now,
          // before the visitor has to send another message. Dedupe (seenAt) makes
          // it safe for poll + POST to render the same message.
          if (data.escalate) { humanMode = true; startPolling(); }
          // After the first message, ask name + email (desktop) so the shop can
          // follow up even if the visitor closes the tab.
          maybeAskContact();
          return;
        }
        // No state field = an inline notice (busy / limit reached), not stored.
        addMsg((data && data.reply) || "Sorry, I didn't catch that. Call or text (403) 452-4283 and we'll help.", 'bot');
      })
      .catch(function () {
        typing.remove();
        addMsg("Couldn't reach us just now - please call or text (403) 452-4283.", 'bot');
      })
      .finally(function () {
        sending = false;
        // While the gate is up, keep the chat input disabled — they fill the form.
        if (!gateEl) { sendBtn.disabled = false; input.focus(); }
      });
  }

  // After the per-chat cap, offer an OPTIONAL follow-up (name + phone/email).
  // Asking is not required to chat; it just lets the shop reach back out. The
  // chat input stays disabled once capped (the AI won't reply further).
  function showFollowUp() {
    if (gateEl) return;
    input.disabled = true; sendBtn.disabled = true;
    gateEl = document.createElement('div');
    gateEl.className = 'pt-chat__gate';
    gateEl.innerHTML =
      '<div class="pt-chat__gate-title">Want us to follow up? Leave your details (optional).</div>' +
      '<input class="pt-chat__gate-input" type="text" placeholder="Your name" autocomplete="name" />' +
      '<input class="pt-chat__gate-input" type="text" placeholder="Phone or email" autocomplete="email" />' +
      '<button class="pt-chat__gate-btn" type="button">Send my info</button>' +
      '<div class="pt-chat__gate-err"></div>';
    msgs.appendChild(gateEl);
    msgs.scrollTop = msgs.scrollHeight;
    var fields = gateEl.querySelectorAll('.pt-chat__gate-input');
    var nameI = fields[0], contactI = fields[1];
    var btn = gateEl.querySelector('.pt-chat__gate-btn');
    var err = gateEl.querySelector('.pt-chat__gate-err');
    setTimeout(function () { nameI.focus(); }, 60);
    function submitContact() {
      var nm = (nameI.value || '').trim();
      var ct = (contactI.value || '').trim();
      if (!nm || !ct) { err.textContent = 'Please add your name and a phone or email.'; return; }
      var payload = { sessionId: sessionId(), name: nm };
      if (ct.indexOf('@') > -1) payload.email = ct; else payload.phone = ct;
      btn.disabled = true; btn.textContent = 'Sending...'; err.textContent = '';
      fetch(contactUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) {
            gateEl.remove(); gateEl = null;
            addMsg("Thanks! We'll be in touch soon.", 'bot');
          } else {
            btn.disabled = false; btn.textContent = 'Send my info';
            err.textContent = (d && d.error) || 'Please check your details and try again.';
          }
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = 'Send my info';
          err.textContent = 'Could not send just now. Please try again.';
        });
    }
    btn.addEventListener('click', submitContact);
    contactI.addEventListener('keydown', function (e) { if (e.key === 'Enter') submitContact(); });
  }

  // --- Desktop contact capture (after the first message) -------------------
  // The visitor asks their question first, then we ask for name + email so the
  // shop can reply even if they leave. Required to keep chatting; stored via
  // /api/chat/contact (which also alerts the shop). Mobile never gets here — the
  // mobile "Chat" tab opens SMS instead of the web chat.
  function maybeAskContact() {
    if (contactCaptured || gateEl || bookingFormEl || mq.matches) return;
    if (userMsgCount < 1) return;
    showContactGate();
  }
  function showContactGate() {
    if (gateEl || contactCaptured) return;
    input.disabled = true; sendBtn.disabled = true;
    gateEl = document.createElement('div');
    gateEl.className = 'pt-chat__gate';
    gateEl.innerHTML =
      '<div class="pt-chat__gate-title">Quick one so we can reply — your name and email?</div>' +
      '<input class="pt-chat__gate-input" data-cg-name type="text" placeholder="Your name" autocomplete="name" />' +
      '<input class="pt-chat__gate-input" data-cg-email type="email" placeholder="Your email" autocomplete="email" inputmode="email" />' +
      '<button class="pt-chat__gate-btn" type="button">Continue chatting</button>' +
      '<div class="pt-chat__gate-err"></div>';
    msgs.appendChild(gateEl);
    msgs.scrollTop = msgs.scrollHeight;
    var nameI = gateEl.querySelector('[data-cg-name]');
    var emailI = gateEl.querySelector('[data-cg-email]');
    var btn = gateEl.querySelector('.pt-chat__gate-btn');
    var err = gateEl.querySelector('.pt-chat__gate-err');
    setTimeout(function () { nameI.focus(); }, 60);
    function submitInfo() {
      var nm = (nameI.value || '').trim();
      var em = (emailI.value || '').trim();
      if (!nm) { err.textContent = 'Please add your name.'; return; }
      if (em.indexOf('@') < 1 || em.lastIndexOf('.') < em.indexOf('@')) { err.textContent = 'Please add a valid email.'; return; }
      btn.disabled = true; btn.textContent = 'Saving...'; err.textContent = '';
      fetch(contactUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: sessionId(), name: nm, email: em })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) {
            contactCaptured = true;
            try { localStorage.setItem('pt_chat_contact', '1'); } catch (e) {}
            gateEl.remove(); gateEl = null;
            input.disabled = false; sendBtn.disabled = false; input.focus();
            addMsg('Thanks, ' + nm.split(' ')[0] + "! Ask away — we've got your email if we get cut off.", 'bot');
          } else {
            btn.disabled = false; btn.textContent = 'Continue chatting';
            err.textContent = (d && d.error) || 'Please check your details and try again.';
          }
        })
        .catch(function () {
          btn.disabled = false; btn.textContent = 'Continue chatting';
          err.textContent = 'Could not save just now. Please try again.';
        });
    }
    btn.addEventListener('click', submitInfo);
    emailI.addEventListener('keydown', function (e) { if (e.key === 'Enter') submitInfo(); });
  }

  // Photo upload — read a tire-sidewall / VIN photo, show a thumbnail, and send
  // it for the agent's vision read (reads the size or VIN and finds tires).
  var fileInput = root.querySelector('[data-pt-chat-file]');
  var photoBtn = root.querySelector('[data-pt-chat-photo]');
  if (photoBtn && fileInput) {
    photoBtn.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      fileInput.value = '';
      if (!f) return;
      if (f.size > 5 * 1024 * 1024) { addMsg("That photo's a bit large - try one under 5 MB.", 'bot'); return; }
      var reader = new FileReader();
      reader.onload = function () {
        var dataUrl = String(reader.result || '');
        var comma = dataUrl.indexOf(',');
        if (comma < 0 || dataUrl.indexOf('data:image/') !== 0) return;
        var mime = dataUrl.slice(5, comma).split(';')[0];
        var b64 = dataUrl.slice(comma + 1);
        var wrap = document.createElement('div');
        wrap.className = 'pt-chat__msg pt-chat__msg--user pt-chat__msg--photo';
        var im = new Image(); im.src = dataUrl; im.className = 'pt-chat__thumb'; im.alt = 'Your photo';
        wrap.appendChild(im);
        msgs.appendChild(wrap); msgs.scrollTop = msgs.scrollHeight;
        sendMessage('', false, { data: b64, mimeType: mime });
      };
      reader.readAsDataURL(f);
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = (input.value || '').trim();
    if (!text) return;
    input.value = '';
    sendMessage(text);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-collection-compare"] && !Shopify.designMode) return;
  try {
    (function() {
    var tray = document.querySelector('[data-compare-tray]');
    var itemsWrap = document.querySelector('[data-compare-items]');
    var countEl = document.querySelector('[data-compare-count]');
    var openBtn = document.querySelector('[data-compare-open]');
    var clearBtn = document.querySelector('[data-compare-clear]');
    var modal = document.querySelector('[data-compare-modal]');
    var tableWrap = document.querySelector('[data-compare-table]');
    var radarWrap = document.querySelector('[data-compare-radar]');
    if (!tray) return;

    var compareList = [];
    var MAX_COMPARE = 3;

    function updateTray() {
      if (compareList.length === 0) {
        tray.classList.remove('is-visible');
        return;
      }
      tray.classList.add('is-visible');
      countEl.textContent = compareList.length;
      openBtn.disabled = compareList.length < 2;

      var html = '';
      compareList.forEach(function(item) {
        html += '<div class="ptg__compare-item">' +
          (item.img ? '<img src="' + item.img + '" alt="">' : '') +
          '<span>' + item.vendor + ' ' + item.title + '</span>' +
          '<button type="button" class="ptg__compare-item-remove" data-remove-id="' + item.id + '">&times;</button>' +
        '</div>';
      });
      itemsWrap.innerHTML = html;

      itemsWrap.querySelectorAll('[data-remove-id]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          removeFromCompare(this.dataset.removeId);
        });
      });
    }

    function addToCompare(data) {
      if (compareList.length >= MAX_COMPARE) return;
      if (compareList.find(function(i) { return i.id === data.id; })) return;
      compareList.push(data);
      updateTray();
    }

    function removeFromCompare(id) {
      compareList = compareList.filter(function(i) { return i.id !== id; });
      var cb = document.querySelector('.ptg__compare-check[data-compare-id="' + id + '"]');
      if (cb) cb.checked = false;
      updateTray();
    }

    document.querySelectorAll('.ptg__compare-check').forEach(function(cb) {
      cb.addEventListener('change', function() {
        if (this.checked) {
          if (compareList.length >= MAX_COMPARE) { this.checked = false; return; }
          addToCompare({
            id: this.dataset.compareId,
            title: this.dataset.compareTitle,
            vendor: this.dataset.compareVendor,
            price: this.dataset.comparePrice,
            setPrice: this.dataset.compareSet,
            img: this.dataset.compareImg,
            size: this.dataset.compareSize,
            url: this.dataset.compareUrl,
            season: this.dataset.compareSeason,
            type: this.dataset.compareType,
            speed: this.dataset.compareSpeed,
            load: this.dataset.compareLoad,
            warranty: this.dataset.compareWarranty
          });
        } else {
          removeFromCompare(this.dataset.compareId);
        }
      });
    });

    if (clearBtn) clearBtn.addEventListener('click', function() {
      compareList = [];
      document.querySelectorAll('.ptg__compare-check').forEach(function(cb) { cb.checked = false; });
      updateTray();
    });

    function buildTable() {
      var rows = [
        { label: '', key: 'img', render: function(v) { return v.img ? '<img src="' + v.img + '" alt="">' : ''; } },
        { label: 'Brand', key: 'vendor' },
        { label: 'Model', key: 'title' },
        { label: 'Size', key: 'size' },
        { label: 'Price / tire', key: 'price', cls: 'ptg__cmp-price', render: function(v) { return '$' + v.price; } },
        { label: 'Set of 4', key: 'setPrice', render: function(v) { return '$' + v.setPrice; } },
        { label: 'Season', key: 'season' },
        { label: 'Type', key: 'type' },
        { label: 'Speed rating', key: 'speed' },
        { label: 'Load index', key: 'load' },
        { label: 'Warranty', key: 'warranty' },
        { label: '', key: 'url', render: function(v) { return '<a href="' + v.url + '" class="ptg__cmp-link">View tire →</a>'; } }
      ];

      var html = '<table class="ptg__cmp-table">';
      rows.forEach(function(row) {
        html += '<tr><th>' + row.label + '</th>';
        compareList.forEach(function(item) {
          var val = row.render ? row.render(item) : (item[row.key] || '—');
          html += '<td' + (row.cls ? ' class="' + row.cls + '"' : '') + '>' + val + '</td>';
        });
        html += '</tr>';
      });
      html += '</table>';
      tableWrap.innerHTML = html;
    }

    // Hexagon radar — six axes derived from existing compare data
    function scoreFor(item, axis) {
      function pickNum(s, def) {
        var m = String(s || '').match(/(\d+)/);
        return m ? parseInt(m[1], 10) : def;
      }
      var speedRank = { Y: 100, W: 90, V: 80, ZR: 95, H: 70, U: 65, T: 60, S: 50, R: 45, Q: 40 };
      switch (axis) {
        case 'performance': {
          var c = String(item.speed || '').toUpperCase().match(/[A-Z]{1,2}/);
          return c && speedRank[c[0]] != null ? speedRank[c[0]] : 50;
        }
        case 'load': {
          var li = pickNum(item.load, 90);
          return Math.max(20, Math.min(100, (li - 70) * 3));
        }
        case 'snow': {
          var s = String(item.season || '').toLowerCase();
          if (s.indexOf('winter') !== -1) return 95;
          if (s.indexOf('all-weather') !== -1) return 80;
          if (s.indexOf('all-season') !== -1) return 50;
          if (s.indexOf('summer') !== -1 || s.indexOf('performance') !== -1) return 15;
          return 45;
        }
        case 'durability': {
          var w = pickNum(item.warranty, 0);
          if (!w) return 50;
          return Math.max(30, Math.min(100, w / 1000));
        }
        case 'comfort': {
          var t = String(item.type || '').toLowerCase();
          if (t.indexOf('mud') !== -1) return 35;
          if (t.indexOf('all-terrain') !== -1 || t.indexOf('a/t') !== -1) return 55;
          if (t.indexOf('performance') !== -1) return 65;
          if (t.indexOf('highway') !== -1 || t.indexOf('touring') !== -1) return 90;
          return 70;
        }
        case 'value': {
          var prices = compareList.map(function (i) { return parseFloat(String(i.price).replace(/[^0-9.]/g, '')) || 0; });
          var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
          var p = parseFloat(String(item.price).replace(/[^0-9.]/g, '')) || 0;
          if (max === min) return 70;
          return Math.round(100 - ((p - min) / (max - min)) * 80);
        }
      }
      return 50;
    }

    function buildRadar() {
      if (!radarWrap) return;
      if (compareList.length === 0) { radarWrap.innerHTML = ''; return; }

      var AXES = [
        { key: 'performance', label: 'Performance' },
        { key: 'load',        label: 'Load' },
        { key: 'snow',        label: 'Snow grip' },
        { key: 'durability',  label: 'Durability' },
        { key: 'comfort',     label: 'Comfort' },
        { key: 'value',       label: 'Value' }
      ];
      var COLORS = ['#dc2626', '#2563eb', '#16a34a'];

      var size = 320, cx = size / 2, cy = size / 2, R = 110;
      function point(angle, r) {
        return [cx + r * Math.cos(angle), cy + r * Math.sin(angle)];
      }

      var svg = '<svg class="ptg__cmp-radar-svg" viewBox="0 0 ' + size + ' ' + size + '" xmlns="http://www.w3.org/2000/svg" aria-label="Tire comparison radar">';

      [0.25, 0.5, 0.75, 1].forEach(function (frac) {
        var pts = AXES.map(function (_, i) {
          var ang = (Math.PI * 2 * i) / AXES.length - Math.PI / 2;
          return point(ang, R * frac).join(',');
        }).join(' ');
        svg += '<polygon class="ptg__cmp-radar-grid" points="' + pts + '"></polygon>';
      });

      AXES.forEach(function (axis, i) {
        var ang = (Math.PI * 2 * i) / AXES.length - Math.PI / 2;
        var end = point(ang, R);
        svg += '<line class="ptg__cmp-radar-axis" x1="' + cx + '" y1="' + cy + '" x2="' + end[0] + '" y2="' + end[1] + '"></line>';
        var labelP = point(ang, R + 22);
        var anchor = 'middle';
        if (labelP[0] > cx + 8) anchor = 'start';
        else if (labelP[0] < cx - 8) anchor = 'end';
        svg += '<text class="ptg__cmp-radar-axis-label" x="' + labelP[0] + '" y="' + (labelP[1] + 4) + '" text-anchor="' + anchor + '">' + axis.label + '</text>';
      });

      compareList.forEach(function (item, idx) {
        var color = COLORS[idx % COLORS.length];
        var pts = AXES.map(function (axis, i) {
          var ang = (Math.PI * 2 * i) / AXES.length - Math.PI / 2;
          var s = Math.max(0, Math.min(100, scoreFor(item, axis.key)));
          return point(ang, R * (s / 100)).join(',');
        }).join(' ');
        svg += '<polygon class="ptg__cmp-radar-poly" points="' + pts + '" stroke="' + color + '" fill="' + color + '"></polygon>';
      });

      svg += '</svg>';

      var legend = '<div class="ptg__cmp-radar-legend">';
      compareList.forEach(function (item, idx) {
        var color = COLORS[idx % COLORS.length];
        var name = (item.vendor + ' ' + item.title).slice(0, 40);
        legend += '<span class="ptg__cmp-radar-legend-item"><span class="ptg__cmp-radar-legend-dot" style="background:' + color + '"></span>' + name + '</span>';
      });
      legend += '</div>';

      radarWrap.innerHTML =
        '<h4 class="ptg__cmp-radar-title">At-a-glance trade-offs</h4>' +
        '<p class="ptg__cmp-radar-sub">Scores derived from speed rating, load index, season, type and warranty. Higher = better on that axis.</p>' +
        '<div class="ptg__cmp-radar-chart-wrap">' + svg + '</div>' +
        legend;
    }

    if (openBtn) openBtn.addEventListener('click', function() {
      if (compareList.length < 2) return;
      buildTable();
      buildRadar();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });

    function closeModal() {
      if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
    }

    document.querySelectorAll('[data-compare-modal-close]').forEach(function(el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-collection-empty"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-ptg-empty]');
    if (!root) return;
    var webhook = root.dataset.webhook || '';

    // ─── "Clear all filters" CTA ───────────────────────────────────────
    var clearBtn = root.querySelector('[data-clear-all-empty]');
    if (clearBtn) clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = window.location.pathname;
    });

    // ─── Auto-fire webhook when customer landed with size filters ──────
    // Only fires once per unique size combo per tab (sessionStorage dedup).
    try {
      var params = new URLSearchParams(window.location.search);
      var w = params.get('filter.p.m.custom.tire_width');
      var a = params.get('filter.p.m.custom.tire_profile');
      var r = params.get('filter.p.m.custom.rim_diameter');
      if (webhook && !root.hasAttribute('data-wheels') && (w || a || r)) {
        var sizeStr = (w || '?') + '/' + (a || '?') + 'R' + (r || '?');
        var dedupKey = '__pt_empty_' + sizeStr;
        if (!sessionStorage.getItem(dedupKey)) {
          sessionStorage.setItem(dedupKey, '1');
          fetch(webhook, {
            method: 'POST',
            headers: { 'Content-Type': 'text/plain;charset=utf-8' },
            body: JSON.stringify({
              vehicle:    'OUT OF STOCK: ' + sizeStr,
              year: '', make: '', model: '', trim: '',
              page_url:   window.location.href,
              user_agent: navigator.userAgent,
              timestamp:  new Date().toISOString()
            })
          }).catch(function () { /* best-effort */ });
        }
      }
    } catch (e) { /* never break the page */ }

    // ─── Missing-vehicle mini-form ────────────────────────────────────
    var form = root.querySelector('[data-empty-missing-form]');
    var status = root.querySelector('[data-empty-missing-status]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input');
      var vehicle = (input.value || '').trim();
      if (!vehicle) return;
      var btn = form.querySelector('button');
      var orig = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Sending...';
      function setStatus(msg, kind) {
        status.textContent = msg;
        status.className = 'ptg__empty-missing-status' + (kind ? ' is-' + kind : '');
        status.hidden = !msg;
      }
      if (!webhook) {
        window.location.href = 'mailto:info@princetires.ca?subject=' + encodeURIComponent('Missing tire: ' + vehicle) +
          '&body=' + encodeURIComponent('Tire request: ' + vehicle + '\nPage: ' + window.location.href);
        btn.disabled = false; btn.textContent = orig;
        return;
      }
      fetch(webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({
          vehicle:    'EMPTY-COLLECTION: ' + vehicle,
          year: '', make: '', model: '', trim: '',
          page_url:   window.location.href,
          user_agent: navigator.userAgent,
          timestamp:  new Date().toISOString()
        })
      }).then(function (r) {
        if (r.ok || r.status === 302) {
          setStatus("Thanks — we'll be in touch.", 'success');
          input.value = '';
        } else { throw new Error('HTTP ' + r.status); }
      }).catch(function () {
        setStatus("Couldn't send — opening your email app.", 'error');
        window.location.href = 'mailto:info@princetires.ca?subject=' + encodeURIComponent('Missing tire: ' + vehicle);
      }).finally(function () {
        btn.disabled = false; btn.textContent = orig;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-collection-garage-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-pt-gb]');
    if (!root) return;
    var SESSION_KEY = 'ptg_garage_banner_dismissed';

    // Hide forever this session if dismissed
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return;
    } catch (e) {}

    // Only show on the broad collection (no size filter applied)
    var params = new URLSearchParams(window.location.search);
    if (params.has('filter.p.m.custom.tire_width')) return;

    // ─── Collect saved vehicles ───────────────────────────────────────
    var vehicles = [];
    try {
      Object.keys(localStorage).filter(function (k) {
        return k.indexOf('pt-garage-') === 0;
      }).forEach(function (k) {
        var arr = JSON.parse(localStorage.getItem(k) || '[]');
        if (Array.isArray(arr)) arr.forEach(function (v) {
          if (v && v.year && v.make && v.model) {
            vehicles.push({
              isDefault: !!v.isDefault,
              year: v.year, make: v.make, model: v.model,
              trim: v.trim || '', nickname: v.nickname || '',
              size: v.tireSize || (v.sizes && v.sizes[0]) || ''
            });
          }
        });
      });
    } catch (e) {}
    try {
      var raw = localStorage.getItem('pt-tire-search-vehicle');
      if (raw) {
        var ts = JSON.parse(raw);
        if (ts && ts.year && ts.make && ts.model) {
          var firstSize = ts.sizes && ts.sizes.length ? ts.sizes[0] : '';
          var dup = vehicles.some(function (v) {
            return v.year == ts.year && v.make === ts.make && v.model === ts.model;
          });
          if (!dup) vehicles.push({
            isDefault: false,
            year: ts.year, make: ts.make, model: ts.model,
            trim: ts.trim || '', nickname: '',
            size: firstSize
          });
        }
      }
    } catch (e) {}

    vehicles = vehicles.filter(function (v) { return v.size; });
    if (vehicles.length === 0) return;

    vehicles.sort(function (a, b) {
      if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1;
      return 0;
    });

    // ─── Render single vs multi state ─────────────────────────────────
    var elSingle = root.querySelector('[data-pt-gb-single]');
    var elMulti = root.querySelector('[data-pt-gb-multi]');
    var elName = root.querySelector('[data-pt-gb-name]');
    var elSize = root.querySelector('[data-pt-gb-size]');
    var elPicker = root.querySelector('[data-pt-gb-picker]');

    function vehicleLabel(v) {
      var name = v.nickname || (v.year + ' ' + v.make + ' ' + v.model + (v.trim ? ' ' + v.trim : ''));
      return name + ' (' + v.size + ')';
    }

    if (vehicles.length === 1) {
      var v = vehicles[0];
      var name = v.nickname || (v.year + ' ' + v.make + ' ' + v.model);
      if (elName) elName.textContent = name;
      if (elSize) elSize.textContent = '(' + v.size + ')';
      elSingle.hidden = false;
    } else {
      var html = '';
      vehicles.forEach(function (vh, i) {
        html += '<option value="' + i + '">' + vehicleLabel(vh).replace(/"/g, '&quot;') + '</option>';
      });
      elPicker.innerHTML = html;
      elMulti.hidden = false;
    }

    root.hidden = false;

    // ─── Apply on Yes ─────────────────────────────────────────────────
    function parseSize(s) {
      var m = String(s || '').match(/(\d{3})\s*\/\s*(\d{2,3})\s*R\s*(\d{2})/i);
      return m ? { w: m[1], a: m[2], r: m[3] } : null;
    }

    root.querySelector('[data-pt-gb-yes]').addEventListener('click', function () {
      var v = vehicles.length === 1
        ? vehicles[0]
        : vehicles[parseInt(elPicker.value, 10) || 0];
      var parts = parseSize(v.size);
      if (!parts) return;
      var newParams = new URLSearchParams();
      // Keep vendor + season + service_type filters that are already on the URL
      params.forEach(function (val, k) {
        if (k === 'filter.p.vendor' ||
            k === 'filter.p.m.custom.seasonality' ||
            k === 'filter.p.m.custom.service_type') newParams.append(k, val);
      });
      newParams.set('filter.p.m.custom.tire_width', parts.w);
      newParams.set('filter.p.m.custom.tire_profile', parts.a);
      newParams.set('filter.p.m.custom.rim_diameter', parts.r);
      window.location.href = window.location.pathname + '?' + newParams.toString();
    });

    // ─── Dismiss on No ────────────────────────────────────────────────
    root.querySelector('[data-pt-gb-no]').addEventListener('click', function () {
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
      root.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-collection-garage-pill"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-pt-gp]');
    if (!root) return;
    var chipHas = root.querySelector('[data-pt-gp-chip-has]');
    var chipLabel = root.querySelector('[data-pt-gp-chip-label]');
    var popover = root.querySelector('[data-pt-gp-popover]');
    var picker = root.querySelector('[data-pt-gp-picker]');
    var applyBtn = root.querySelector('[data-pt-gp-apply]');
    var chipSignin = root.querySelector('[data-pt-gp-signin]');
    var chipAdd = root.querySelector('[data-pt-gp-add]');
    var isLoggedIn = root.dataset.loggedIn === '1';

    function showState(name) {
      chipHas.hidden = name !== 'has';
      chipSignin.hidden = name !== 'signin';
      chipAdd.hidden = name !== 'add';
      root.hidden = false;
    }
    function setChip(label) { if (chipLabel) chipLabel.textContent = label; }

    // ─── Collect every saved vehicle ───────────────────────────────────
    var vehicles = [];
    try {
      Object.keys(localStorage).filter(function (k) {
        return k.indexOf('pt-garage-') === 0;
      }).forEach(function (k) {
        var arr = JSON.parse(localStorage.getItem(k) || '[]');
        if (Array.isArray(arr)) arr.forEach(function (v) {
          if (v && v.year && v.make && v.model) {
            vehicles.push({
              source: 'garage', isDefault: !!v.isDefault,
              year: v.year, make: v.make, model: v.model,
              trim: v.trim || '', nickname: v.nickname || '',
              size: v.tireSize || (v.sizes && v.sizes[0]) || ''
            });
          }
        });
      });
    } catch (e) {}
    try {
      var raw = localStorage.getItem('pt-tire-search-vehicle');
      if (raw) {
        var ts = JSON.parse(raw);
        if (ts && ts.year && ts.make && ts.model) {
          var firstSize = ts.sizes && ts.sizes.length ? ts.sizes[0] : '';
          var dup = vehicles.some(function (v) {
            return v.year === ts.year && v.make === ts.make && v.model === ts.model && v.trim === (ts.trim || '');
          });
          if (!dup) {
            vehicles.push({
              source: 'search', isDefault: false,
              year: ts.year, make: ts.make, model: ts.model,
              trim: ts.trim || '', nickname: '',
              size: firstSize
            });
          }
        }
      }
    } catch (e) {}

    vehicles = vehicles.filter(function (v) { return v.size; });

    if (vehicles.length === 0) {
      if (isLoggedIn) {
        setChip('Add car');
        showState('add');
      } else {
        setChip('Sign in');
        showState('signin');
      }
    } else {
      vehicles.sort(function (a, b) {
        if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1;
        if (a.source !== b.source) return a.source === 'garage' ? -1 : 1;
        return 0;
      });
      var html = '';
      vehicles.forEach(function (v, i) {
        var name = v.nickname || (v.year + ' ' + v.make + ' ' + v.model + (v.trim ? ' ' + v.trim : ''));
        html += '<option value="' + i + '">' + name.replace(/"/g, '&quot;') + ' (' + v.size + ')</option>';
      });
      picker.innerHTML = html;
      var primary = vehicles[0];
      setChip(primary.nickname || (primary.make + ' ' + primary.model));
      var badge = root.querySelector('[data-pt-gp-chip-badge]');
      if (badge && vehicles.length > 1) {
        badge.textContent = '+' + (vehicles.length - 1);
        badge.hidden = false;
      }
      showState('has');
    }

    // ─── Popover open/close (only on has-state chip) ────────────────────
    function openPopover() {
      popover.hidden = false;
      chipHas.setAttribute('aria-expanded', 'true');
    }
    function closePopover() {
      popover.hidden = true;
      chipHas.setAttribute('aria-expanded', 'false');
    }
    chipHas.addEventListener('click', function (e) {
      e.stopPropagation();
      if (popover.hidden) openPopover(); else closePopover();
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closePopover();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popover.hidden) { closePopover(); chipHas.focus(); }
    });

    // ─── Apply: navigate with the picked vehicle's size as filter ──────
    function parseSize(s) {
      var m = String(s || '').match(/(\d{3})\s*\/\s*(\d{2,3})\s*R\s*(\d{2})/i);
      return m ? { w: m[1], a: m[2], r: m[3] } : null;
    }
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        var v = vehicles[parseInt(picker.value, 10) || 0];
        if (!v) return;
        var parts = parseSize(v.size);
        if (!parts) return;
        var params = new URLSearchParams(window.location.search);
        var newParams = new URLSearchParams();
        params.forEach(function (val, k) {
          if (k === 'filter.p.vendor' ||
              k === 'filter.p.m.custom.seasonality' ||
              k === 'filter.p.m.custom.service_type') {
            newParams.append(k, val);
          }
        });
        newParams.set('filter.p.m.custom.tire_width', parts.w);
        newParams.set('filter.p.m.custom.tire_profile', parts.a);
        newParams.set('filter.p.m.custom.rim_diameter', parts.r);
        window.location.href = window.location.pathname + '?' + newParams.toString();
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-collection-research-strip"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-pt-rs]');
    if (!root) return;

    var assetBase = root.dataset.assetBase;
    var assetVersion = root.dataset.assetVersion || '';
    var manifestUrl = root.dataset.manifestUrl || '';
    var vehicleManifest = null;
    var STORAGE_KEY = 'pt-tire-search-vehicle';

    var elToggle = root.querySelector('[data-pt-rs-toggle]');
    var elBody = root.querySelector('[data-pt-rs-body]');
    var tabs = root.querySelectorAll('[data-pt-rs-tab]');
    var panels = root.querySelectorAll('[data-pt-rs-panel]');

    var elWidth = root.querySelector('[data-pt-rs-width]');
    var elAspect = root.querySelector('[data-pt-rs-aspect]');
    var elRim = root.querySelector('[data-pt-rs-rim]');
    var elSubmitSize = root.querySelector('[data-pt-rs-submit-size]');

    var elYear = root.querySelector('[data-pt-rs-year]');
    var elMake = root.querySelector('[data-pt-rs-make]');
    var elModel = root.querySelector('[data-pt-rs-model]');
    var elTrim = root.querySelector('[data-pt-rs-trim]');
    var elSubmitVeh = root.querySelector('[data-pt-rs-submit-vehicle]');
    var elStatus = root.querySelector('[data-pt-rs-status]');
    var elClearSize = root.querySelector('[data-pt-rs-clear-size]');
    var elClearVeh = root.querySelector('[data-pt-rs-clear-vehicle]');
    var elSaved = root.querySelector('[data-pt-rs-saved]');
    var elSavedList = root.querySelector('[data-pt-rs-saved-list]');

    var yearData = null;
    var params = new URLSearchParams(window.location.search);

    /* Cross-surface search analytics — one pt_search_submit + one
       pt_search_result per SEARCH. Schema + outcomes:
       snippets/pt-search-tracking.liquid.

       Walking the cascade emits nothing; a search is reported when the
       customer commits (a submit button or a saved-car chip) or when it
       dead-ends. */
    function ptSearch(method, outcome, d) {
      if (!window.PTTrack) return;
      d = d || {};
      var key = [method, d.year, d.make, d.model, d.trim, d.size, outcome].join('|');
      window.PTTrack.once('rs-s|' + key, 'pt_search_submit', {
        surface: 'collection_strip', method: method,
        year: d.year, make: d.make, model: d.model, trim: d.trim, size: d.size
      });
      window.PTTrack.once('rs-r|' + key, 'pt_search_result', {
        surface: 'collection_strip', method: method, outcome: outcome,
        sizes_count: d.sizes_count || 0, trims_count: d.trims_count, status: d.status,
        year: d.year, make: d.make, model: d.model, size: d.size
      });
    }

    /* Navigate without dropping the event we just queued — see PTTrack.go. */
    function ptGo(url) {
      if (window.PTTrack && typeof window.PTTrack.go === 'function') window.PTTrack.go(url);
      else window.location.href = url;
    }

    // ─── Tab switching ───────────────────────────────────────────────
    function activateTab(name) {
      tabs.forEach(function (t) {
        var active = t.dataset.ptRsTab === name;
        t.classList.toggle('pt-rs__tab--active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var active = p.dataset.ptRsPanel === name;
        p.classList.toggle('pt-rs__panel--active', active);
        p.hidden = !active;
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activateTab(t.dataset.ptRsTab); });
    });

    // ─── Mobile toggle ───────────────────────────────────────────────
    if (elToggle) {
      elToggle.addEventListener('click', function () {
        var open = root.hasAttribute('data-open');
        if (open) root.removeAttribute('data-open');
        else root.setAttribute('data-open', '');
        elToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }

    // ─── Size-system toggle (metric ↔ flotation / off-road) ──────────
    // Off-road sizes (35X12.50R20) feed the same metafields as metric, so the
    // submit handler needs no change — only the dropdown values + labels swap.
    var RS_FLOT_OPTS = {
      width:  ['27','30','31','33','35','37','38','39','40'],
      aspect: ['8.50','9.50','10.00','10.50','12.50','13.50','15.50'],
      rim:    ['14','15','17','18','20','22','24']
    };
    var RS_SIZE_LABELS = {
      metric:    { width: 'Width', aspect: 'Aspect', rim: 'Rim' },
      flotation: { width: 'Diameter', aspect: 'Width', rim: 'Rim' }
    };
    var RS_SIZE_EL = { width: elWidth, aspect: elAspect, rim: elRim };
    var RS_METRIC_OPTS = {};
    Object.keys(RS_SIZE_EL).forEach(function (k) {
      var el = RS_SIZE_EL[k];
      RS_METRIC_OPTS[k] = el
        ? Array.prototype.slice.call(el.options).map(function (o) { return o.value; }).filter(Boolean)
        : [];
    });
    var sizeMode = 'metric';
    function applySizeMode(mode) {
      sizeMode = mode === 'flotation' ? 'flotation' : 'metric';
      var opts = sizeMode === 'flotation' ? RS_FLOT_OPTS : RS_METRIC_OPTS;
      Object.keys(RS_SIZE_EL).forEach(function (k) {
        var sel = RS_SIZE_EL[k];
        if (sel) {
          sel.innerHTML = '<option value="">—</option>' +
            opts[k].map(function (v) { return '<option value="' + v + '">' + v + '</option>'; }).join('');
        }
        var lbl = root.querySelector('[data-pt-rs-lbl="' + k + '"]');
        if (lbl) lbl.textContent = RS_SIZE_LABELS[sizeMode][k];
      });
      root.querySelectorAll('[data-pt-rs-sizemode]').forEach(function (b) {
        var on = b.dataset.ptRsSizemode === sizeMode;
        b.classList.toggle('pt-rs__sizemode-btn--active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    root.querySelectorAll('[data-pt-rs-sizemode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (sizeMode === btn.dataset.ptRsSizemode) return;
        applySizeMode(btn.dataset.ptRsSizemode);
        updateSizeClear();
      });
    });

    // ─── Pre-fill the Size tab from URL ──────────────────────────────
    var urlW = params.get('filter.p.m.custom.tire_width');
    var urlA = params.get('filter.p.m.custom.tire_profile');
    var urlR = params.get('filter.p.m.custom.rim_diameter');
    // Flotation sizes carry a 2-digit width (30-40) and a decimal profile.
    if ((urlW && urlW.length <= 2) || (urlA && urlA.indexOf('.') !== -1)) {
      applySizeMode('flotation');
    }
    if (urlW) elWidth.value = urlW;
    if (urlA) elAspect.value = urlA;
    if (urlR) elRim.value = urlR;
    function updateSizeClear() {
      if (!elClearSize) return;
      elClearSize.hidden = !(elWidth.value || elAspect.value || elRim.value);
    }
    [elWidth, elAspect, elRim].forEach(function (s) { s.addEventListener('change', updateSizeClear); });
    updateSizeClear();
    if (elClearSize) elClearSize.addEventListener('click', function () {
      elWidth.value = elAspect.value = elRim.value = '';
      updateSizeClear();
    });

    // ─── Collect every saved vehicle (garage + tire-search) ──────────
    var savedVehicles = [];
    try {
      Object.keys(localStorage).filter(function (k) {
        return k.indexOf('pt-garage-') === 0;
      }).forEach(function (k) {
        var arr = JSON.parse(localStorage.getItem(k) || '[]');
        if (Array.isArray(arr)) arr.forEach(function (v) {
          if (v && v.year && v.make && v.model) {
            savedVehicles.push({
              isDefault: !!v.isDefault,
              year: String(v.year), make: v.make, model: v.model,
              trim: v.trim || '', nickname: v.nickname || '',
              size: v.tireSize || (v.sizes && v.sizes[0]) || ''
            });
          }
        });
      });
    } catch (e) {}
    var savedVeh = null;
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (parsed && parsed.year) {
          savedVeh = parsed;
          var dup = savedVehicles.some(function (v) {
            return v.year === String(parsed.year) && v.make === parsed.make && v.model === parsed.model;
          });
          if (!dup) savedVehicles.push({
            isDefault: false,
            year: String(parsed.year), make: parsed.make, model: parsed.model,
            trim: parsed.trim || '', nickname: '',
            size: (parsed.sizes && parsed.sizes[0]) || parsed.tireSize || ''
          });
        }
      }
    } catch (e) {}

    // ─── Tab default ─────────────────────────────────────────────────
    var hasSize = !!(urlW || urlA || urlR);
    if (!hasSize && savedVeh) activateTab('vehicle');

    // ─── Render saved-cars quick-pick row ────────────────────────────
    function renderSavedCars() {
      if (!elSaved || !elSavedList) return;
      if (savedVehicles.length === 0) { elSaved.hidden = true; return; }
      savedVehicles.sort(function (a, b) {
        if (a.isDefault !== b.isDefault) return a.isDefault ? -1 : 1;
        return 0;
      });
      var html = '';
      savedVehicles.forEach(function (v, i) {
        var label = v.nickname || (v.year + ' ' + v.make + ' ' + v.model + (v.trim ? ' ' + v.trim : ''));
        html += '<button type="button" class="pt-rs__saved-chip" data-saved-i="' + i + '">' + label.replace(/"/g, '&quot;') + '</button>';
      });
      elSavedList.innerHTML = html;
      elSaved.hidden = false;
      elSavedList.querySelectorAll('[data-saved-i]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = savedVehicles[parseInt(btn.dataset.savedI, 10) || 0];
          if (!v || !v.size) {
            flashStatus('No size on file for this car.');
            ptSearch('saved_vehicle', 'no_sizes', v ? { year: v.year, make: v.make, model: v.model, trim: v.trim, sizes_count: 0 } : { sizes_count: 0 });
            return;
          }
          applyVehicleSize(v);
        });
      });
    }
    function applyVehicleSize(v) {
      var m = String(v.size).match(/(\d{3})\s*\/\s*(\d{2,3})\s*R\s*(\d{2})/i);
      if (!m) {
        flashStatus("Couldn't parse size '" + v.size + "'.");
        ptSearch('saved_vehicle', 'no_sizes', { year: v.year, make: v.make, model: v.model, trim: v.trim, sizes_count: 0 });
        return;
      }
      ptSearch('saved_vehicle', 'sizes', { year: v.year, make: v.make, model: v.model, trim: v.trim, size: v.size, sizes_count: 1 });
      var newParams = new URLSearchParams();
      params.forEach(function (val, k) {
        if (k === 'filter.p.vendor' ||
            k === 'filter.p.m.custom.seasonality' ||
            k === 'filter.p.m.custom.service_type') newParams.append(k, val);
      });
      newParams.set('filter.p.m.custom.tire_width', m[1]);
      newParams.set('filter.p.m.custom.tire_profile', m[2]);
      newParams.set('filter.p.m.custom.rim_diameter', m[3]);
      ptGo(window.location.pathname + '?' + newParams.toString());
    }
    renderSavedCars();

    // ─── Size tab submit ─────────────────────────────────────────────
    elSubmitSize.addEventListener('click', function () {
      var w = elWidth.value;
      var a = elAspect.value;
      var r = elRim.value;
      if (!w || !a || !r) {
        flashStatus('Pick width, aspect, and rim to search.');
        return;
      }
      var newParams = new URLSearchParams();
      // Keep vendor + seasonality + service_type from the current URL
      params.forEach(function (v, k) {
        if (k === 'filter.p.vendor' ||
            k === 'filter.p.m.custom.seasonality' ||
            k === 'filter.p.m.custom.service_type') {
          newParams.append(k, v);
        }
      });
      newParams.set('filter.p.m.custom.tire_width', w);
      newParams.set('filter.p.m.custom.tire_profile', a);
      newParams.set('filter.p.m.custom.rim_diameter', r);
      ptSearch('dropdown', 'sizes', {
        size: w + (sizeMode === 'flotation' ? 'X' : '/') + a + 'R' + r,
        sizes_count: 1
      });
      ptGo(window.location.pathname + '?' + newParams.toString());
    });

    // ─── Vehicle cascade ─────────────────────────────────────────────
    function resetSelect(el, placeholder) {
      el.innerHTML = '<option value="">' + placeholder + '</option>';
      el.disabled = true;
    }
    function fillSelect(el, placeholder, items) {
      var html = '<option value="">' + placeholder + '</option>';
      items.forEach(function (it) { html += '<option value="' + it + '">' + it + '</option>'; });
      el.innerHTML = html;
      el.disabled = false;
    }
    function flashStatus(msg) {
      if (!elStatus) return;
      elStatus.textContent = msg;
      elStatus.hidden = false;
      setTimeout(function () { elStatus.hidden = true; }, 4000);
    }

    elYear.addEventListener('change', function () { onYearChange(elYear.value); });
    elMake.addEventListener('change', function () { onMakeChange(elMake.value); });
    elModel.addEventListener('change', function () { onModelChange(elModel.value); });
    elTrim.addEventListener('change', function () { onTrimChange(elTrim.value); });

    function onYearChange(year) {
      yearData = null;
      resetSelect(elMake, '—');
      resetSelect(elModel, '—');
      resetSelect(elTrim, '—');
      elSubmitVeh.disabled = true;
      if (!year) return;
      var url = window.PTVehicleManifest
        ? window.PTVehicleManifest.yearUrl(assetBase, year, vehicleManifest, assetVersion)
        : assetBase + 'pt-vehicle-' + year + '.json' + (assetVersion ? '?' + assetVersion : '');
      fetch(url, { cache: 'force-cache' })
        .then(function (r) {
          if (!r.ok) { var e = new Error('HTTP ' + r.status); e.ptStatus = r.status; throw e; }
          return r.json();
        })
        .then(function (data) {
          yearData = data;
          var makes = data.makes || Object.keys(data.models || {});
          makes.sort();
          fillSelect(elMake, '— pick make —', makes);
        })
        .catch(function (err) {
          flashStatus("Couldn't load data for " + year + ". Try another year.");
          // OUR data is missing, not the customer's car: assets/pt-vehicle-*.json
          // is .shopifyignore'd and only published to the MAIN theme, so this
          // fires for every year on a dev or freshly published theme.
          // 'data_error' keeps it out of the customer-failure rate.
          ptSearch('dropdown', 'data_error', {
            year: year, sizes_count: 0,
            status: (err && err.ptStatus) || 0
          });
        });
    }

    function onMakeChange(make) {
      resetSelect(elModel, '—');
      resetSelect(elTrim, '—');
      elSubmitVeh.disabled = true;
      if (!make || !yearData) return;
      var models = Object.keys((yearData.models || {})[make] || {});
      models.sort();
      fillSelect(elModel, '— pick model —', models);
    }

    function onModelChange(model) {
      resetSelect(elTrim, '—');
      elSubmitVeh.disabled = true;
      if (!model || !yearData) return;
      var make = elMake.value;
      var trims = Object.keys(((yearData.models || {})[make] || {})[model] || {});
      trims.sort();
      fillSelect(elTrim, '— pick trim —', trims);
    }

    function onTrimChange(trim) {
      elSubmitVeh.disabled = !trim;
      updateVehicleClear();
    }
    function updateVehicleClear() {
      if (!elClearVeh) return;
      elClearVeh.hidden = !(elYear.value || elMake.value || elModel.value || elTrim.value);
    }
    [elYear, elMake, elModel, elTrim].forEach(function (s) { s.addEventListener('change', updateVehicleClear); });
    if (elClearVeh) elClearVeh.addEventListener('click', function () {
      yearData = null;
      elYear.value = '';
      resetSelect(elMake, '—');
      resetSelect(elModel, '—');
      resetSelect(elTrim, '—');
      elSubmitVeh.disabled = true;
      updateVehicleClear();
    });

    elSubmitVeh.addEventListener('click', function () {
      var make = elMake.value;
      var model = elModel.value;
      var trim = elTrim.value;
      if (!yearData || !trim) return;
      var sizes = ((yearData.models || {})[make] || {})[model][trim];
      var ptV = { year: elYear.value, make: make, model: model, trim: trim };
      if (!sizes || !sizes.length) {
        flashStatus("We don't have OEM size data for this trim.");
        ptV.sizes_count = 0;
        ptSearch('dropdown', 'no_sizes', ptV);
        return;
      }
      // Use the first size (staggered front, typically). Persist the vehicle.
      var firstSize = sizes[0];
      var parsed = parseSize(firstSize);
      if (!parsed) {
        flashStatus("Couldn't parse size '" + firstSize + "'. Try another trim.");
        ptV.sizes_count = 0;
        ptSearch('dropdown', 'no_sizes', ptV);
        return;
      }
      ptV.size = firstSize;
      ptV.sizes_count = sizes.length;
      ptSearch('dropdown', 'sizes', ptV);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          year: elYear.value, make: make, model: model, trim: trim,
          sizes: sizes, savedAt: new Date().toISOString()
        }));
      } catch (e) {}
      var newParams = new URLSearchParams();
      // Keep vendor + seasonality + service_type from the current URL
      params.forEach(function (v, k) {
        if (k === 'filter.p.vendor' ||
            k === 'filter.p.m.custom.seasonality' ||
            k === 'filter.p.m.custom.service_type') {
          newParams.append(k, v);
        }
      });
      newParams.set('filter.p.m.custom.tire_width', parsed.w);
      newParams.set('filter.p.m.custom.tire_profile', parsed.a);
      newParams.set('filter.p.m.custom.rim_diameter', parsed.r);
      ptGo(window.location.pathname + '?' + newParams.toString());
    });

    // ─── Helpers ─────────────────────────────────────────────────────
    function parseSize(s) {
      var p = window.PTTireParse && window.PTTireParse.parseSize(s);
      return p && { w: p.width, a: p.profile, r: p.rim };
    }

    // Year list is data-driven: rebuild it from pt-vehicle-manifest.json when
    // that loads (Liquid-rendered years stay on a 404). The saved-car pre-seed
    // waits up to 1.5s so a newly published year finds its option.
    var PTVM = window.PTVehicleManifest;
    function applyVehicleManifest(m) {
      if (!m) return;
      vehicleManifest = m;
      PTVM.fillYearSelect(elYear, PTVM.yearsDesc(m));
    }
    if (PTVM) PTVM.load(manifestUrl).then(applyVehicleManifest);
    var manifestReady = PTVM ? PTVM.ready(manifestUrl, 1500).then(applyVehicleManifest) : Promise.resolve();
    var yearAtInit = elYear.value;

    // Pre-seed the vehicle cascade from savedVeh
    if (savedVeh) manifestReady.then(function () {
      if (elYear.value !== yearAtInit) return; // customer picked a year while we waited
      elYear.value = savedVeh.year || '';
      if (savedVeh.year) {
        onYearChange(savedVeh.year);
        // Sequencing: makes load async; we wait for the fetch to populate makes
        // before applying make/model/trim. Use a chained timeout-based wait.
        var waitForMakes = function (tries) {
          if (tries > 30) return;
          if (elMake.options.length > 1) {
            if (savedVeh.make) {
              elMake.value = savedVeh.make;
              onMakeChange(savedVeh.make);
              if (savedVeh.model) {
                elModel.value = savedVeh.model;
                onModelChange(savedVeh.model);
                if (savedVeh.trim) {
                  elTrim.value = savedVeh.trim;
                  onTrimChange(savedVeh.trim);
                }
              }
            }
            return;
          }
          setTimeout(function () { waitForMakes(tries + 1); }, 100);
        };
        waitForMakes(0);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-fits-vehicles"] && !Shopify.designMode) return;
  try {
    (function () {
    var el = document.querySelector('[data-ptp-fits]');
    if (!el) return;
    var api = el.getAttribute('data-api');
    var size = el.getAttribute('data-size');
    var bolt = el.getAttribute('data-bolt');
    var rd = el.getAttribute('data-rd'), rw = el.getAttribute('data-rw'), ro = el.getAttribute('data-ro'), cb = el.getAttribute('data-cb');
    var qs = '';
    if (size) {
      qs = 'size=' + encodeURIComponent(size);
    } else if (bolt && rd && rw && ro) {
      qs = 'bolt_pattern=' + encodeURIComponent(bolt) + '&rim_diameter=' + encodeURIComponent(rd) + '&rim_width=' + encodeURIComponent(rw) + '&rim_offset=' + encodeURIComponent(ro);
      // Without a center bore the API claims no vehicles (same rule as custom.compatible_vehicles).
      if (cb) qs += '&center_bore=' + encodeURIComponent(cb);
    } else {
      return;
    }
    var vendor = el.getAttribute('data-vendor'), model = el.getAttribute('data-model');
    if (vendor && model) qs += '&vendor=' + encodeURIComponent(vendor) + '&model=' + encodeURIComponent(model);

    function go() {
      fetch(api + '?' + qs)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d) return;
          var shown = false;
          var txt = el.querySelector('.ptp-fits__text');
          if (d.count && d.count > 0) {
            var names = (d.sample || []).slice(0, 3).map(function (v) { return v.make + ' ' + v.model; });
            var n = d.count >= 1000 ? (Math.floor(d.count / 100) * 100).toLocaleString() + '+' : d.count;
            var lead = 'Fits ' + n + ' vehicle' + (d.count === 1 ? '' : 's');
            txt.textContent = names.length ? lead + ' incl. ' + names.join(', ') : lead;
            shown = true;
          }
          if (d.rating && typeof d.rating.score === 'number') {
            var rt = el.querySelector('.ptp-fits__rating');
            rt.textContent = '★ ' + Math.round(d.rating.score) + '/100' + (d.rating.pros && d.rating.pros.length ? ' · ' + d.rating.pros.slice(0, 2).join(', ') : '');
            if (d.rating.proLink) { rt.href = d.rating.proLink; } else { rt.removeAttribute('href'); }
            rt.hidden = false;
            shown = true;
          }
          if (shown) el.hidden = false;
        })
        .catch(function () {});
    }
    if ('requestIdleCallback' in window) { requestIdleCallback(go, { timeout: 1500 }); } else { setTimeout(go, 300); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-pwa-install"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'pt-pwa-install-dismissed';
    var DAYS = 30;
    var el = document.getElementById('pt-pwa-install');
    if (!el) return;

    // Mobile-only
    if (window.matchMedia('(min-width: 769px)').matches) return;

    // Already installed? Hide forever for this session.
    var isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true;
    if (isStandalone) return;

    // Recently dismissed?
    try {
      var until = parseInt(localStorage.getItem(KEY) || '0', 10);
      if (until && Date.now() < until) return;
    } catch (e) {}

    var sub = document.getElementById('pt-pwa-install__sub');
    var cta = document.getElementById('pt-pwa-install__cta');
    var closeBtn = document.getElementById('pt-pwa-install__close');
    var deferredPrompt = null;

    function show() {
      el.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { el.classList.add('is-open'); });
    }
    function hideAndRemember() {
      el.classList.remove('is-open');
      setTimeout(function () { el.hidden = true; }, 280);
      try {
        localStorage.setItem(KEY, String(Date.now() + DAYS * 86400000));
      } catch (e) {}
    }

    var ua = navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    var isSafari = isIOS && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);

    if (isIOS && isSafari) {
      // iOS: no programmatic install — show instructions.
      sub.textContent = 'Tap Share, then "Add to Home Screen".';
      cta.textContent = 'Got it';
      cta.addEventListener('click', hideAndRemember);
      closeBtn.addEventListener('click', hideAndRemember);
      show();
      return;
    }

    // Android / Chromium: wait for the install event.
    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      deferredPrompt = e;
      show();
    });

    cta.addEventListener('click', function () {
      if (!deferredPrompt) { hideAndRemember(); return; }
      deferredPrompt.prompt();
      deferredPrompt.userChoice.finally(function () {
        deferredPrompt = null;
        hideAndRemember();
      });
    });
    closeBtn.addEventListener('click', hideAndRemember);

    window.addEventListener('appinstalled', function () {
      try { localStorage.setItem(KEY, String(Date.now() + 365 * 86400000)); } catch (e) {}
      el.hidden = true;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-quote-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay, lastFocus;

    function $(id) { return document.getElementById(id); }

    function recalc() {
      if (!overlay) overlay = $("ptq-overlay");
      var qty = parseInt($("ptq-qty").value, 10) || 0;
      var price = parseFloat($("ptq-price").value) || 0;
      var total = qty * price;
      if (overlay) {
        overlay.querySelectorAll(".ptq-addon").forEach(function (row) {
          var check = row.querySelector(".ptq-addon-check");
          var input = row.querySelector(".ptq-addon-input");
          if (check && check.checked && input) total += qty * (parseFloat(input.value) || 0);
        });
      }
      $("ptq-total").textContent = "$" + total.toFixed(2);
    }

    function collectAddons() {
      var out = [];
      if (!overlay) return out;
      overlay.querySelectorAll(".ptq-addon").forEach(function (row) {
        var check = row.querySelector(".ptq-addon-check");
        if (!check || !check.checked) return;
        var input = row.querySelector(".ptq-addon-input");
        var price = parseFloat(input && input.value);
        if (isNaN(price) || price < 0) return;
        var slug = row.dataset.addonSlug || "custom";
        var nameInput = row.querySelector(".ptq-addon-name-input");
        var labelEl = row.querySelector(".ptq-addon-label");
        var name = nameInput ? nameInput.value.trim() : labelEl ? labelEl.textContent.trim() : slug;
        if (!name) return;
        out.push({ slug: slug, name: name, unitPrice: price });
      });
      return out;
    }

    function bindAddonCheck(check) {
      check.addEventListener("change", function () {
        var row = check.closest(".ptq-addon");
        var input = row && row.querySelector(".ptq-addon-input");
        if (input && !row.classList.contains("ptq-addon--custom")) input.disabled = !check.checked;
        recalc();
      });
    }

    function addCustomAddon() {
      var wrap = $("ptq-custom-addons");
      if (!wrap) return;
      var row = document.createElement("div");
      row.className = "ptq-addon ptq-addon--custom";
      row.dataset.addonSlug = "custom";
      row.innerHTML =
        '<label class="ptq-addon-toggle"><input type="checkbox" class="ptq-addon-check" checked></label>' +
        '<input type="text" class="ptq-addon-name-input" placeholder="Add-on name">' +
        '<div class="ptq-addon-price"><span class="ptq-addon-dollar">$</span><input type="number" class="ptq-addon-input" step="0.01" min="0" inputmode="decimal"></div>' +
        '<button type="button" class="ptq-addon-remove" aria-label="Remove">×</button>';
      wrap.appendChild(row);
      bindAddonCheck(row.querySelector(".ptq-addon-check"));
      row.querySelector(".ptq-addon-input").addEventListener("input", recalc);
      row.querySelector(".ptq-addon-remove").addEventListener("click", function () {
        if (row.parentNode) row.parentNode.removeChild(row);
        recalc();
      });
      row.querySelector(".ptq-addon-name-input").focus();
    }

    window.openQuoteModal = function (btn) {
      overlay = $("ptq-overlay");
      if (!overlay) return;
      lastFocus = document.activeElement;
      var d = btn.dataset;
      overlay.dataset.handle = d.productHandle || "";
      overlay.dataset.variantId = d.variantId || "";

      var mode = d.quoteMode || "staff";
      overlay.dataset.mode = mode;

      var priceCents = parseInt(d.tirePrice || "0", 10) || 0;
      var priceDollars = (priceCents / 100).toFixed(2);
      overlay.dataset.origPrice = priceDollars;

      $("ptq-tire-name").textContent = d.tireName || "Tire";
      var sizeEl = $("ptq-tire-size");
      sizeEl.textContent = d.tireSize || "";
      sizeEl.hidden = !d.tireSize;

      // Price defaults to retail for everyone (staff + wholesale), fully editable.
      // The Prince Tires price-match line is hidden on white-label reseller quotes.
      var priceInput = $("ptq-price");
      var pmRow = $("ptq-pricematch-row");
      priceInput.value = priceDollars;
      if (pmRow) pmRow.hidden = mode === "wholesale";

      // Seed add-on default prices from the button; reset toggles + custom rows.
      var addonDefaults = {
        mount_balance: d.addonMount,
        levy: d.addonLevy,
        valve: d.addonValve,
        disposal: d.addonDisposal,
        tpms: d.addonTpms,
      };
      overlay.querySelectorAll(".ptq-addon[data-addon-slug]").forEach(function (row) {
        if (row.classList.contains("ptq-addon--custom")) return;
        var slug = row.dataset.addonSlug;
        var input = row.querySelector(".ptq-addon-input");
        var check = row.querySelector(".ptq-addon-check");
        var def = parseFloat(addonDefaults[slug] || "0") || 0;
        if (input) { input.value = def ? def.toFixed(2) : ""; input.disabled = true; }
        if (check) check.checked = false;
      });
      var customWrap = $("ptq-custom-addons");
      if (customWrap) customWrap.innerHTML = "";

      $("ptq-qty").value = 4;
      $("ptq-email").value = "";
      $("ptq-phone").value = "";
      $("ptq-note").value = "";
      $("ptq-pricematch").checked = true;

      $("ptq-success").hidden = true;
      $("ptq-body").hidden = false;
      var err = $("ptq-error");
      err.hidden = true;
      err.textContent = "";

      recalc();
      overlay.hidden = false;
      document.body.style.overflow = "hidden";
      $("ptq-email").focus();
    };

    window.closeQuoteModal = function () {
      if (!overlay) overlay = $("ptq-overlay");
      if (overlay) overlay.hidden = true;
      document.body.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    window.ptqAnother = function () {
      $("ptq-success").hidden = true;
      $("ptq-body").hidden = false;
      $("ptq-email").value = "";
      $("ptq-phone").value = "";
      $("ptq-note").value = "";
      var err = $("ptq-error");
      err.hidden = true;
      err.textContent = "";
      $("ptq-email").focus();
    };

    function channelLine(label, status) {
      var map = {
        sent: "✓ sent",
        skipped: "—",
        failed: "✗ failed",
        unconfigured: "not set up yet",
      };
      if (status === "skipped") return "";
      return label + ": " + (map[status] || status);
    }

    window.ptqSend = function () {
      var btn = $("ptq-send");
      var err = $("ptq-error");
      err.hidden = true;
      err.textContent = "";

      var email = $("ptq-email").value.trim();
      var phone = $("ptq-phone").value.trim();
      if (!email && !phone) {
        err.textContent = "Enter a customer email or phone number.";
        err.hidden = false;
        return;
      }

      var mode = overlay.dataset.mode || "staff";
      var qty = parseInt($("ptq-qty").value, 10) || 4;
      var priceVal = $("ptq-price").value.trim();

      var body = {
        productHandle: overlay.dataset.handle || null,
        variantId: overlay.dataset.variantId,
        customerEmail: email || null,
        customerPhone: phone || null,
        quantity: qty,
        // Price-match is a Prince Tires line — off for white-label reseller quotes.
        priceMatch: mode === "wholesale" ? false : $("ptq-pricematch").checked,
        note: $("ptq-note").value.trim() || null,
        addons: collectAddons(),
      };
      // Send a price override only when it differs from the prefilled retail price.
      if (priceVal !== "" && priceVal !== overlay.dataset.origPrice) {
        body.unitPrice = parseFloat(priceVal);
      }

      var defaultLabel = btn.getAttribute("data-label") || "Send quote";
      btn.disabled = true;
      btn.textContent = "Sending…";

      fetch("/apps/api/quote", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j }; });
        })
        .then(function (res) {
          btn.disabled = false;
          btn.textContent = defaultLabel;
          if (!res.ok || !res.j || !res.j.ok) {
            err.textContent = (res.j && res.j.error) || "Could not send the quote. Try again.";
            err.hidden = false;
            return;
          }
          var ch = res.j.channels || {};
          var lines = [channelLine("Email", ch.email), channelLine("Text", ch.sms)].filter(Boolean);
          $("ptq-channels").textContent = lines.join("  ·  ");
          var link = $("ptq-link");
          link.href = res.j.quoteUrl;
          link.textContent = res.j.quoteUrl;
          $("ptq-body").hidden = true;
          $("ptq-success").hidden = false;
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = defaultLabel;
          err.textContent = "Network error — please try again.";
          err.hidden = false;
        });
    };

    function init() {
      var ov = $("ptq-overlay");
      if (!ov) return;
      // Recalc total live.
      ov.querySelectorAll("[data-ptq-recalc]").forEach(function (el) {
        el.addEventListener("input", recalc);
      });
      // Add-on toggles + custom add-on button.
      ov.querySelectorAll(".ptq-addon-check").forEach(bindAddonCheck);
      var addBtn = $("ptq-addon-add");
      if (addBtn) addBtn.addEventListener("click", addCustomAddon);
      // Click backdrop or press Escape to close.
      ov.addEventListener("mousedown", function (e) {
        if (e.target === ov) window.closeQuoteModal();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !ov.hidden) window.closeQuoteModal();
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-rim-visualizer"] && !Shopify.designMode) return;
  try {
    (function () {
    var el = document.querySelector('[data-ptp-viz]');
    if (!el) return;
    var api = el.getAttribute('data-api');
    var rim = el.getAttribute('data-rim');
    if (rim && rim.indexOf('//') === 0) rim = 'https:' + rim; // protocol-relative -> absolute
    var assetBase = el.dataset.assetBase || '';
    var assetVersion = el.dataset.assetVersion || '';
    var manifestUrl = el.dataset.manifestUrl || '';

    var yearI = el.querySelector('[data-ptp-viz-year]');
    var makeI = el.querySelector('[data-ptp-viz-make]');
    var modelI = el.querySelector('[data-ptp-viz-model]');
    var btn = el.querySelector('[data-ptp-viz-go]');
    var out = el.querySelector('[data-ptp-viz-out]');
    var msg = el.querySelector('[data-ptp-viz-msg]');

    var yearData = null;       // the loaded pt-vehicle-{year}.json
    var manifest = null;
    var loadingYear = null;    // guards out-of-order year fetches

    function show(m) { msg.textContent = m; msg.hidden = !m; }

    function fill(sel, placeholder, values, keep) {
      var current = keep && values.indexOf(keep) !== -1 ? keep : '';
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = placeholder;
      sel.appendChild(o);
      values.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v; opt.textContent = v;
        sel.appendChild(opt);
      });
      sel.value = current;
      sel.disabled = values.length === 0;
    }

    function reset(sel, placeholder) {
      sel.innerHTML = '<option value="">' + placeholder + '</option>';
      sel.disabled = true;
    }

    function syncBtn() {
      btn.disabled = !(yearI.value && makeI.value && modelI.value);
    }

    // Loads the year's catalogue, then fills makes (and, when restoring a saved
    // car, the model too). Returns a promise so the prefill can chain on it.
    function loadYear(year, wantMake, wantModel) {
      yearData = null;
      reset(makeI, 'Make');
      reset(modelI, 'Model');
      syncBtn();
      if (!year) return Promise.resolve();
      loadingYear = year;
      var url = window.PTVehicleManifest
        ? window.PTVehicleManifest.yearUrl(assetBase, year, manifest, assetVersion)
        : assetBase + 'pt-vehicle-' + year + '.json' + (assetVersion ? '?' + assetVersion : '');
      return fetch(url, { cache: 'force-cache' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (data) {
          if (loadingYear !== year) return; // a newer year won the race
          yearData = data;
          var makes = (data.makes || Object.keys(data.models || {})).slice().sort();
          fill(makeI, 'Make', makes, wantMake);
          if (makeI.value) fillModels(makeI.value, wantModel);
          syncBtn();
        })
        .catch(function () {
          if (loadingYear !== year) return;
          show("Couldn't load vehicles for " + year + '.');
        });
    }

    function fillModels(make, wantModel) {
      reset(modelI, 'Model');
      if (!make || !yearData) { syncBtn(); return; }
      var models = Object.keys((yearData.models || {})[make] || {}).sort();
      fill(modelI, 'Model', models, wantModel);
      syncBtn();
    }

    yearI.addEventListener('change', function () { show(''); loadYear(yearI.value); });
    makeI.addEventListener('change', function () { show(''); fillModels(makeI.value); });
    modelI.addEventListener('change', function () { show(''); syncBtn(); });

    function go() {
      var year = yearI.value, make = makeI.value, model = modelI.value;
      if (!year || !make || !model) { show('Pick your year, make and model.'); return; }
      show('Rendering your vehicle…'); out.hidden = true; out.innerHTML = '';
      btn.disabled = true;
      var qs = 'year=' + encodeURIComponent(year) + '&make=' + encodeURIComponent(make) + '&model=' + encodeURIComponent(model) + '&rim=' + encodeURIComponent(rim);
      fetch(api + '?' + qs)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.image) {
            var img = new Image();
            img.className = 'ptp-viz__img';
            img.alt = make + ' ' + model + ' with these wheels';
            img.onload = function () { out.appendChild(img); out.hidden = false; show(''); };
            img.onerror = function () { show("Couldn't load the preview — try again."); };
            img.src = d.image;
          } else {
            // The car came from OUR dropdown, so it is not a typo: either the
            // configurator has no template for it or the render failed.
            show("We don't have a preview for that vehicle yet — ask us in chat and we'll show you.");
          }
        })
        .catch(function () { show("Couldn't render just now — please try again."); })
        .finally(syncBtn);
    }
    btn.addEventListener('click', go);

    // The car the shopper already told us about, from any surface.
    function savedVehicle() {
      try {
        var raw = localStorage.getItem('pt-tire-search-vehicle');
        if (!raw) return null;
        var v = JSON.parse(raw);
        return v && v.year && v.make && v.model ? v : null;
      } catch (e) { return null; }
    }

    function start() {
      var saved = savedVehicle();
      if (!saved) return;
      var y = String(saved.year);
      // only if the year is actually offered on this select
      if (!Array.prototype.some.call(yearI.options, function (o) { return o.value === y; })) return;
      yearI.value = y;
      loadYear(y, String(saved.make), String(saved.model)).then(function () {
        if (yearI.value && makeI.value && modelI.value) {
          // Filled in, deliberately NOT rendered — a render is an upstream call.
          show('Showing for your ' + saved.year + ' ' + saved.make + ' ' + saved.model + ' — hit Visualize.');
        }
      });
    }

    if (window.PTVehicleManifest) {
      window.PTVehicleManifest.ready(manifestUrl, 1500).then(function (m) {
        manifest = m;
        if (m) window.PTVehicleManifest.fillYearSelect(yearI, window.PTVehicleManifest.yearsDesc(m));
        start();
      });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pt-wheel-search"] && !Shopify.designMode) return;
  try {
    (function () {
    // One closure per instance: the homepage hero renders this snippet twice
    // (Wheels tab + Packages tab), and a page-wide querySelector would leave
    // the second one dead. Everything below is scoped to its own root.
    document.querySelectorAll('[data-pt-ws]').forEach(init);

    function init(root) {
      var target = root.dataset.target || '/collections/wheels';
      var apiBase = root.dataset.apiBase || '';
      var assetBase = root.dataset.assetBase || '';
      var assetVersion = root.dataset.assetVersion || '';
      var manifestUrl = root.dataset.manifestUrl || '';
      var facetsUrl = root.dataset.facetsUrl || '/collections/wheels?view=facets';
      var lazySpecs = root.dataset.lazySpecs === '1';
      var pkgUrl = root.dataset.packageUrl || '';
      var F = 'filter.p.m.custom.';

      var catalogBolts = [];
      try {
        var node = root.querySelector('[data-pt-ws-bolts]');
        catalogBolts = node ? JSON.parse(node.textContent) : [];
      } catch (e) { catalogBolts = []; }

      var elYear = root.querySelector('[data-pt-ws-year]');
      var elMake = root.querySelector('[data-pt-ws-make]');
      var elModel = root.querySelector('[data-pt-ws-model]');
      var elTrim = root.querySelector('[data-pt-ws-trim]'); // package mode only
      var elGo = root.querySelector('[data-pt-ws-submit-vehicle]');
      var elStatus = root.querySelector('[data-pt-ws-status]');
      var elToggle = root.querySelector('[data-pt-ws-toggle]');
      var elBody = root.querySelector('[data-pt-ws-body]');

      var yearData = null, manifest = null, loadingYear = null;

      function status(m) { if (elStatus) elStatus.textContent = m || ''; }

      function fill(sel, placeholder, values) {
        sel.innerHTML = '';
        var o = document.createElement('option');
        o.value = ''; o.textContent = placeholder;
        sel.appendChild(o);
        values.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = v; opt.textContent = v;
          sel.appendChild(opt);
        });
        sel.disabled = values.length === 0;
      }
      // Package mode names its empty selects (its labels are hidden on phones).
      function reset(sel) { sel.innerHTML = '<option value="">' + (sel.getAttribute('data-pt-ws-ph') || '—') + '</option>'; sel.disabled = true; }
      // A trim is required only when the year file lists some (package mode).
      function sync() { elGo.disabled = !(elYear.value && elMake.value && elModel.value && (!elTrim || elTrim.disabled || elTrim.value)); }

      // Off a collection page there is no collection.filters, so pull the same
      // data from Shopify's facet index as JSON. Once per page, cached for the
      // session; a failure leaves the tab usable with "Any" everywhere.
      var facetsPromise = null;
      function loadFacets() {
        if (facetsPromise) return facetsPromise;
        var cached = null;
        try { cached = JSON.parse(sessionStorage.getItem('pt-ws-facets') || 'null'); } catch (e) {}
        facetsPromise = cached
          ? Promise.resolve(cached)
          // NO Accept: application/json here — that header makes Shopify return its
          // own built-in collection JSON instead of rendering the ?view= template.
          : fetch(facetsUrl)
              .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
              .then(function (j) { try { sessionStorage.setItem('pt-ws-facets', JSON.stringify(j)); } catch (e) {} return j; })
              .catch(function () { return null; });
        return facetsPromise;
      }

      function applyFacets(j) {
        if (!j || !Array.isArray(j.filters)) return;
        var by = {};
        j.filters.forEach(function (f) { by[f.param] = f.values || []; });
        root.querySelectorAll('[data-pt-ws-spec]').forEach(function (sel) {
          if (sel.options.length > 1) return; // already filled
          var vals = by[F + sel.dataset.ptWsSpec] || [];
          var prefix = sel.dataset.prefix || '';
          var unit = sel.dataset.unit || '';
          vals.forEach(function (v) {
            var o = document.createElement('option');
            o.value = v.v;
            o.textContent = prefix + v.v + unit + ' (' + v.n + ')';
            sel.appendChild(o);
          });
          sel.disabled = vals.length === 0;
        });
        // the bolt list the vehicle search expands against
        if (!catalogBolts.length) catalogBolts = (by[F + 'bolt_pattern'] || []).slice();
        var hint = root.querySelector('[data-pt-ws-specs-hint]');
        if (hint) hint.hidden = false;
      }

      if (lazySpecs) loadFacets().then(applyFacets);

      if (elToggle) elToggle.addEventListener('click', function () {
        var open = root.classList.toggle('is-open');
        elToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      root.querySelectorAll('[data-pt-ws-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var name = tab.dataset.ptWsTab;
          root.querySelectorAll('[data-pt-ws-tab]').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          root.querySelectorAll('[data-pt-ws-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.ptWsPanel === name);
          });
        });
      });

      function loadYear(year, wantMake, wantModel, wantTrim) {
        yearData = null; reset(elMake); reset(elModel); if (elTrim) reset(elTrim); sync();
        if (!year) return Promise.resolve();
        loadingYear = year;
        var url = window.PTVehicleManifest
          ? window.PTVehicleManifest.yearUrl(assetBase, year, manifest, assetVersion)
          : assetBase + 'pt-vehicle-' + year + '.json' + (assetVersion ? '?' + assetVersion : '');
        return fetch(url, { cache: 'force-cache' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (data) {
            if (loadingYear !== year) return;
            yearData = data;
            fill(elMake, 'Make', (data.makes || Object.keys(data.models || {})).slice().sort());
            if (wantMake) { elMake.value = wantMake; if (elMake.value) fillModels(wantMake, wantModel, wantTrim); }
            sync();
          })
          .catch(function () { if (loadingYear === year) status("Couldn't load vehicles for " + year + '.'); });
      }

      function fillModels(make, wantModel, wantTrim) {
        reset(elModel);
        if (elTrim) reset(elTrim);
        if (!make || !yearData) { sync(); return; }
        fill(elModel, 'Model', Object.keys((yearData.models || {})[make] || {}).sort());
        if (wantModel) { elModel.value = wantModel; if (elTrim && elModel.value) fillTrims(make, wantModel, wantTrim); }
        sync();
      }

      // Package mode: trims in the year file's own order (the builder's
      // order); a single trim is picked for the shopper.
      function fillTrims(make, model, wantTrim) {
        reset(elTrim);
        if (make && model && yearData) {
          var trims = Object.keys(((yearData.models || {})[make] || {})[model] || {});
          fill(elTrim, 'Trim', trims);
          if (trims.length === 1) elTrim.value = trims[0];
          else if (wantTrim) elTrim.value = wantTrim;
        }
        sync();
      }

      elYear.addEventListener('change', function () { status(''); loadYear(elYear.value); });
      elMake.addEventListener('change', function () { status(''); fillModels(elMake.value); });
      elModel.addEventListener('change', function () { status(''); if (elTrim) fillTrims(elMake.value, elModel.value); else sync(); });
      if (elTrim) elTrim.addEventListener('change', sync);

      // "6x139.7" -> every catalogue string drilled for it, e.g.
      // ["6x139.7", "6x135/6x139.7", "6x120/6x139.7"].
      function expandBolt(pcd) {
        if (!pcd) return [];
        var want = String(pcd).trim().toLowerCase();
        return catalogBolts
          .filter(function (b) {
            return String(b.v).toLowerCase().split('/').some(function (part) { return part.trim() === want; });
          })
          .map(function (b) { return b.v; });
      }

      function goVehicle() {
        var year = elYear.value, make = elMake.value, model = elModel.value;
        if (!year || !make || !model) return;
        if (pkgUrl) {
          // Package mode: the builder looks the car up itself. Hand over the
          // names exactly as pt-vehicle-{year}.json spells them — the builder
          // reads the same files and matches y / mk / md / tr case-insensitively.
          var trim = elTrim ? elTrim.value : '';
          window.location.href = pkgUrl + (pkgUrl.indexOf('?') === -1 ? '?' : '&') +
            'y=' + encodeURIComponent(year) + '&mk=' + encodeURIComponent(make) + '&md=' + encodeURIComponent(model) +
            (trim ? '&tr=' + encodeURIComponent(trim) : '');
          return;
        }
        elGo.disabled = true;
        status('Finding wheels for your ' + year + ' ' + make + ' ' + model + '…');
        // Off a collection page the catalogue's bolt strings arrive with the
        // facets, so make sure they are here before expanding the car's PCD —
        // otherwise every car looks like one we stock nothing for.
        var ready = catalogBolts.length ? Promise.resolve() : loadFacets().then(applyFacets);
        ready
          .then(function () { return fetch(apiBase + '/api/wheel-fitment?year=' + encodeURIComponent(year) + '&make=' + encodeURIComponent(make) + '&model=' + encodeURIComponent(model)); })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var bolts = expandBolt(d && d.bolt_pattern);
            if (!bolts.length) {
              // Either we have no spec for the car, or we stock nothing in its
              // pattern. Say which — never send the shopper to an empty grid.
              status(d && d.bolt_pattern
                ? "We don't stock wheels in your " + d.bolt_pattern + " bolt pattern — ask us and we can order them."
                : "We don't have wheel specs for that vehicle yet — ask us in chat.");
              elGo.disabled = false;
              return;
            }
            var qs = [];
            bolts.forEach(function (b) { qs.push(F + 'bolt_pattern=' + encodeURIComponent(b)); });
            var dias = [];
            (d.wheel_sizes || []).forEach(function (w) {
              if (w && w.diameter && dias.indexOf(String(w.diameter)) === -1) dias.push(String(w.diameter));
            });
            dias.forEach(function (x) { qs.push(F + 'rim_diameter=' + encodeURIComponent(x)); });
            var oeTire = (d.tire_sizes || [])[0] || '';
            try {
              localStorage.setItem('pt-tire-search-vehicle', JSON.stringify({
                year: year, make: make, model: model, trim: '',
                tireSize: oeTire, savedAt: new Date().toISOString()
              }));
              // Tells the results page to offer tires for the car just searched.
              sessionStorage.setItem('pt-ws-crosssell', JSON.stringify({
                year: year, make: make, model: model, tireSize: oeTire
              }));
            } catch (e) {}
            window.location.href = target + '?' + qs.join('&');
          })
          .catch(function () { status("Couldn't look that up just now — please try again."); elGo.disabled = false; });
      }
      elGo.addEventListener('click', goVehicle);

      var elSpecGo = root.querySelector('[data-pt-ws-submit-specs]');
      if (elSpecGo) {
        elSpecGo.addEventListener('click', function () {
          var qs = [];
          root.querySelectorAll('[data-pt-ws-spec]').forEach(function (sel) {
            if (sel.value) qs.push(F + sel.dataset.ptWsSpec + '=' + encodeURIComponent(sel.value));
          });
          window.location.href = qs.length ? target + '?' + qs.join('&') : target;
        });
      }

      // ?pt_bolt=6x139.7 — a raw vehicle bolt pattern handed over by another
      // surface (the homepage "wheels that fit" CTA). Expand it against the live
      // facet here, where the catalogue list lives, and rewrite the URL to real
      // filters. Keeps ONE expansion implementation; a copy elsewhere would go
      // stale, which is exactly how the old hardcoded bore list broke.
      function applyBoltHint() {
        var p = new URLSearchParams(window.location.search);
        var hint = p.get('pt_bolt');
        if (!hint) return false;
        var bolts = expandBolt(hint);
        p.delete('pt_bolt');
        if (!bolts.length) {
          // Nothing in stock drilled that way — say so rather than showing an
          // unfiltered grid that looks like it answered the question.
          root.classList.add('is-open');
          status("We don't stock wheels in your " + hint + ' bolt pattern — ask us and we can order them.');
          if (window.history && window.history.replaceState) {
            window.history.replaceState({}, '', window.location.pathname + (p.toString() ? '?' + p : ''));
          }
          return false;
        }
        bolts.forEach(function (b) { p.append(F + 'bolt_pattern', b); });
        window.location.replace(window.location.pathname + '?' + p.toString());
        return true;
      }

      // Prefill from the car the shopper already gave us on another surface.
      function start() {
        var saved = null;
        try {
          var raw = localStorage.getItem('pt-tire-search-vehicle');
          saved = raw ? JSON.parse(raw) : null;
        } catch (e) { saved = null; }
        if (!saved || !saved.year || !saved.make || !saved.model) return;
        var y = String(saved.year);
        if (!Array.prototype.some.call(elYear.options, function (o) { return o.value === y; })) return;
        elYear.value = y;
        loadYear(y, String(saved.make), String(saved.model), saved.trim ? String(saved.trim) : '').then(function () {
          // Package mode skips this line: the filled selects already show the
          // car, and the extra line made the always-open panel taller.
          if (pkgUrl) return;
          if (elYear.value && elMake.value && elModel.value) status('Your ' + y + ' ' + saved.make + ' ' + saved.model + ' — hit Find wheels.');
        });
      }

      // "Want tires too?" — shown on the RESULTS page, after a by-vehicle wheel
      // search, because that is the moment the shopper has the car in mind and
      // has seen the wheels. One-click, using the OE size we already looked up.
      function offerTires() {
        var raw = null;
        try { raw = sessionStorage.getItem('pt-ws-crosssell'); } catch (e) { return; }
        if (!raw) return;
        try { sessionStorage.removeItem('pt-ws-crosssell'); } catch (e) {}
        var v;
        try { v = JSON.parse(raw); } catch (e) { return; }
        if (!v || !v.year || !v.make || !v.model) return;
        var label = v.year + ' ' + v.make + ' ' + v.model;
        var href = v.tireSize
          ? '/collections/tires?' + F + 'tire_size=' + encodeURIComponent(v.tireSize)
          : '/collections/tires';
        var box = document.createElement('div');
        box.className = 'pt-ws__crosssell';
        box.innerHTML =
          '<span>Need tires for your <strong></strong> too?' +
          (v.tireSize ? ' Factory size <strong class="pt-ws__xs-size"></strong>.' : '') +
          '</span><a class="pt-ws__xs-cta" href="' + href + '">Find tires →</a>' +
          '<button type="button" class="pt-ws__xs-no" aria-label="Dismiss">No thanks</button>';
        box.querySelector('strong').textContent = label;
        var sz = box.querySelector('.pt-ws__xs-size');
        if (sz) sz.textContent = v.tireSize;
        box.querySelector('.pt-ws__xs-no').addEventListener('click', function () { box.remove(); });
        root.parentNode.insertBefore(box, root.nextSibling);
      }

      // The bolt hint is a redirect, so resolve it before anything else loads.
      // Neither applies to package mode (no wheel results page behind it).
      if (!pkgUrl) {
        if (applyBoltHint()) return;
        offerTires();
      }

      if (window.PTVehicleManifest) {
        window.PTVehicleManifest.ready(manifestUrl, 1500).then(function (m) {
          manifest = m;
          if (m) window.PTVehicleManifest.fillYearSelect(elYear, window.PTVehicleManifest.yearsDesc(m));
          start();
        });
      } else { start(); }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
